module.exports = __webpack_public_path__ + "img/jzjt.0fb82893.svg";